import useApi from "../../hooks/useApi";
import React, { ReactComponentElement, useEffect, useMemo, useState } from "react";
import Guid from "../../models/Guid";
import { controllerName } from "../../types"
import { useQuery, useQueryClient } from "@tanstack/react-query";;
import { GroupItem, Label, SimpleItem } from "devextreme-react/cjs/form";
import { Button, Gallery } from "devextreme-react";

interface ILookupItem {
  id: Guid
  code: string
  description: string
  texteFr: string
  actif: boolean
  image: string,
  idParent: Guid
}

type IUseLookupParameters = {
  controllerName: controllerName,
  dataField: string,
  currentSelected: any,
  text?: string,
  setDataRow?: Function,
  cacheKey?: string// = `lookup-${controllerName}`,
  staleTime?: number,
  path?: string// = "lookup",
  valueExp?: string// = 'id',
  displayExpr?: string //= "description",
  parameters?: { name: string, value: string }[],
  showFind?: boolean
  showClear?: boolean
  showDropDown?: boolean,
  isModeModifier?: boolean
  disabled?: boolean,
  width?: string
}

const defaultUseLookUpParameterValue = { disabled: false, path: "lookup", valueExp: 'id', displayExpr: 'description', parameters: [], showFind: true, showClear: true, showDropDown: true, staleTime: 10 * 60 * 1000 }

function FileUpload(props: IUseLookupParameters) {
  const {
    controllerName,
    currentSelected,
    dataField,
    text,
    displayExpr,
    valueExp,
    cacheKey,
    staleTime,
    path,
    parameters,
    setDataRow,
    showClear,
    showFind,
    showDropDown,
    isModeModifier,
    disabled,
    width
  } = { ...defaultUseLookUpParameterValue, ...{ cacheKey: `lookup-${props.controllerName}` }, ...props };
  const queryClient = useQueryClient();
  const stringParameter = parameters?.map(p => `${p.name}=${p.value}`).join('&')
  const { getData: getLookUpBase } = useApi<ILookupItem[]>(`${controllerName}/${path}${stringParameter && stringParameter !== "" ? `?${stringParameter}` : ""}`);
  const { data: lookUpBaseData, refetch } = useQuery({
    queryKey: [cacheKey || `lookup-${props.controllerName}`, props.controllerName, getLookUpBase, cacheKey],
    queryFn: () => getLookUpBase(),
    staleTime: staleTime,
    initialData: []
  })
  const { getData: getCurrent } = useApi<ILookupItem>(`${controllerName}`);
  const [img, setImg] = useState('');
  const [currentSelectedItem, setCurrentSelectedItem] = useState<ILookupItem>();

  interface IPopupGestionClientProps {
    onSelectionchanged?: (item: ILookupItem) => void,
    children: ReactComponentElement<any>
  }

  useEffect(() => {
    refetch();

  }, [path, controllerName])

  const editorOptions = useMemo(() => {
    return {
      width: width,
      disabled: disabled,
      searchEnabled: true,
      dataSource: lookUpBaseData,
      displayExpr: displayExpr,
      displayValue: controllerName === "catalogue" ? "idproduit" : `id${controllerName}`,
      valueExpr: valueExp,

      showFileList: false,
      selectButtonText: "+",
      labelText: "",
      accept: "image/*",
      uploadMode: "useForm",

      buttons: [
        {
          name: "remove", options: {
            onClick: () => setDataRow && setDataRow(),
            stylingMode: "text", disabled: disabled,
            icon: "remove",
            visible: showClear
          },
        },
        {
          name: "open-button",
          visible: showDropDown
        }],
      onValueChanged: async (e: any) => {
        getCurrent({ customPath: `${controllerName}/${e.value}` })
          .then((data) => {
            setCurrentSelectedItem(data)
          });

        // if (e?.[0]) {
        //   console.log(e)
        //   // if (e.value?.[0]) {
        //   const file = e[0];
        //   const fr = new FileReader();
        //   await fr.readAsDataURL(file);
        //   fr.onload = () => {
        //     if (fr.result) {
        //       const base64 = fr.result.toString();
        //       // data["image"] = base64;
        //       setImg(base64)
        //     }
        //   };
        // } else {
        //   // alert("File not selected or browser incompatible.")
        // }

        if (e.value.length) {
          console.log(e)
          const file = e.value[0];
          const fr = new FileReader();
          await fr.readAsDataURL(file);
          fr.onload = () => {
            if (fr.result) {
              console.log(fr)
              const base64 = fr.result.toString();
              console.log(base64)
              // data["image"] = base64;
              setImg(base64)
            }
          };

          // var reader = new FileReader();
          //   reader.onload = function (e) {
          //     if (e?.target?.result)
          //       $('#image').attr('src', e.target.result.toString());
          //   }
          //   reader.readAsDataURL(e.value[0]);
        }
      },
    }
  }, [disabled, lookUpBaseData, controllerName, displayExpr, valueExp, getCurrent, setDataRow, showFind, showClear, showDropDown])

  console.log(img)
  return <GroupItem colCount={3} cssClass="testest">
    {/* {text && <Label text={text} />} */}
    <GroupItem>
      <SimpleItem key={"frm-icone-upload"}
        dataField={dataField}
        //editorType={"dxFileUploader"}
        editorOptions={editorOptions}
      >
        <Label text={text} />
      </SimpleItem>
    </GroupItem>
    <GroupItem>
      <SimpleItem>
        <Button
          disabled={!isModeModifier}
          className='fileUploaderDelete'
          // onClick={() => setDataRow()}
          text="X"
        />
      </SimpleItem>
    </GroupItem>
    <GroupItem>
      <SimpleItem>
        <Gallery
          disabled={!isModeModifier}
          className='gestion-types-unites-image'
          dataSource={[`${img}`]}
          // dataSource={[`${currentSelected.image}`]}
          // dataSource={[`data:image/png;base64,${photo}`]}
          noDataText='Pas de données image'
          width={30}
          height={30}
          showIndicator={false}
        />
      </SimpleItem>
    </GroupItem>
  </GroupItem>
  // return {
  //   editorOptions,
  //   data: lookUpBaseData,
  //   currentSelectedItem: currentSelectedItem,
  //   refreshData: () => getLookUpBase(),
  // }
}

export default FileUpload;